// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__fY1sd","switch__label":"switch_switch__label__jktz0","switch__input":"switch_switch__input__H_yKs","switch__slider":"switch_switch__slider__VHns8"};